import React from 'react';
import {
  Box, Grid,
  Typography
} from '@material-ui/core';

import CardList from 'src/components/CardList';

import FieldForm from 'src/views/AdminExperience/Workflows/ManageProcess/FieldForm';
import { FIELD_DETAILS_BY_FIELD_TYPE } from 'src/views/constants/fieldConstants';
import {
  ROLE_ASSIGNMENTS_FIELD
} from 'src/views/constants/tableRendererConstants';
import {
  FIELD_ID, WIDGET_TEXT, WIDGET_TYPE
} from 'src/views/constants/perspectiveConstants';
import { Field, Widget } from 'src/types';
import WidgetTypeMiniCard from 'src/components/miniCards/WidgetTypeMiniCard';
import FieldMiniCard from 'src/components/miniCards/FieldMiniCard';
import PerspectiveDetails from './PerspectiveDetails';

const FieldCard = ({
  field,
}: {
    field: Field,
}) => (
  <div
    id={field.id}
    className="droppable-element"
    draggable
    unselectable="on"
    onDragStart={(e) => {
      const { widgetType } = FIELD_DETAILS_BY_FIELD_TYPE[field.type];
      e.dataTransfer.setData(WIDGET_TYPE, widgetType);
      e.dataTransfer.setData(FIELD_ID, field.id);
      localStorage.setItem(WIDGET_TYPE, widgetType);
    }}
  >
    <FieldMiniCard field={field} />
  </div>
);

interface Props {
  workflowId: string,
  perspectiveId: string,
  refreshPerspective: () => void,
  widgets: Widget[],
  refreshFields: () => void,
  fields: Field[],
}

const widgetCards = [
  {
    label: 'Text',
    description: 'A box full of rich text.',
    icon: 'type',
    widgetType: WIDGET_TEXT,
  },
  {
    label: 'Role assignments',
    description: 'Allow users to assign roles for the engagement',
    widgetType: ROLE_ASSIGNMENTS_FIELD,
    icon: 'user-check',
  }
];

const FormToolbox = ({
  workflowId,
  perspectiveId,
  refreshPerspective,
  widgets,
  refreshFields,
  fields
}: Props) => {
  const selectedFieldIds = widgets.map(
    (widget: any) => widget.fieldId
  ).filter((fieldId: any) => Boolean(fieldId)).map(
    (fieldId: any) => fieldId.toString()
  );

  return (
    <Box>
      <Box mt={2}>
        <Typography variant="h5">
          Details
        </Typography>
        <Box mt={2}>
          <PerspectiveDetails
            workflowId={workflowId}
            perspectiveId={perspectiveId}
            onSuccess={refreshPerspective}
          />
        </Box>
      </Box>
      <Box mt={2}>
        <Typography variant="h5">
          Fields
        </Typography>
        <CardList
          objects={fields.filter((field) => !selectedFieldIds.includes(field.id.toString()))}
          objectType="field"
          httpRequest={() => refreshFields()}
          CardComponent={({
            item
          }: { item: Field }) => <FieldCard field={item} />}
          FormComponent={FieldForm}
          formProps={{ workflowId }}
        />
      </Box>
      <Box mt={2}>
        <Typography variant="h5">
          Widgets
        </Typography>
        <Box pt={2} />
        <Grid container spacing={2}>
          {widgetCards.map((widget) => (
            <Grid item xs={12} key={widget.widgetType}>
              <div
                id={widget.widgetType}
                className="droppable-element"
                draggable
                unselectable="on"
                onDragStart={(e) => {
                  e.dataTransfer.setData(WIDGET_TYPE, widget.widgetType);
                  localStorage.setItem(WIDGET_TYPE, widget.widgetType);
                }}
              >
                <WidgetTypeMiniCard widget={widget} />
              </div>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default FormToolbox;
